import React from 'react'
import { Box } from '@chakra-ui/react'

interface HeadingProps {
  name: string
  isFirst?: boolean
  className?: string
}

const Heading: React.FC<HeadingProps> = ({ name, isFirst, className }) => {
  return (
    <Box
      fontSize="16px"
      fontWeight="500"
      lineHeight={1.3}
      className={className}
      paddingTop={isFirst ? '0px' : '16px'}
      paddingBottom={'16px'}
      color={'#3b485e'}
    >
      {name}
    </Box>
  )
}

export default Heading
